"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Styled = __importStar(require("./styled"));
var MORNING_GRADIENT = "linear-gradient(90deg, #FFCB87 0%, #FF805D 100%)";
var DAY_GRADIENT = "linear-gradient(270deg, #63B2F4 0%, #BDD4ED 100%)";
var EVENING_GRADIENT = "linear-gradient(90deg, #042D60 0%, #456BD7 101.04%)";
var NIGHT_GRADIENT = "linear-gradient(270deg, #787676 0%, #000000 100%)";
var MORNING_IMAGE = "https://github.com/PPO-F-MAN/react-season-component/blob/develop/public/images/morning_icon.png?raw=true";
var DAY_IMAGE = "https://github.com/PPO-F-MAN/react-season-component/blob/develop/public/images/day_icon.png?raw=true";
var EVENING_NIGHT_IMAGE = "https://github.com/PPO-F-MAN/react-season-component/blob/develop/public/images/night_icon.png?raw=true";
var ONE_MINUTE = 60000;
var Time = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? "auto" : _b, _c = _a.animationRoundTime, animationRoundTime = _c === void 0 ? 1 : _c, _d = _a.imagePosition, imagePosition = _d === void 0 ? "left-top" : _d, _e = _a.animation, animation = _e === void 0 ? "left-to-right" : _e, _f = _a.background, background = _f === void 0 ? true : _f;
    var _g = (0, react_1.useState)(0), currentTime = _g[0], setCurrentTime = _g[1];
    var _h = (0, react_1.useState)(MORNING_IMAGE), currentImage = _h[0], setCurrentImage = _h[1];
    var _j = (0, react_1.useState)(MORNING_GRADIENT), currentBackground = _j[0], setCurrentBackground = _j[1];
    var _k = imagePosition.split("-"), x = _k[0], y = _k[1];
    (0, react_1.useEffect)(function () {
        setCurrentTime(new Date().getHours());
        setInterval(function () {
            var hour = new Date().getHours();
            setCurrentTime(hour);
        }, ONE_MINUTE);
    }, []);
    (0, react_1.useEffect)(function () {
        if (type === "auto") {
            if (currentTime <= 6) {
                setCurrentImage(EVENING_NIGHT_IMAGE);
                setCurrentBackground(NIGHT_GRADIENT);
            }
            else if (currentTime <= 12) {
                setCurrentImage(MORNING_IMAGE);
                setCurrentBackground(MORNING_GRADIENT);
            }
            else if (currentTime <= 18) {
                setCurrentImage(DAY_IMAGE);
                setCurrentBackground(DAY_GRADIENT);
            }
            else if (currentTime < 20) {
                setCurrentImage(EVENING_NIGHT_IMAGE);
                setCurrentBackground(EVENING_GRADIENT);
            }
            else {
                setCurrentImage(EVENING_NIGHT_IMAGE);
                setCurrentBackground(NIGHT_GRADIENT);
            }
        }
    }, [currentTime, type]);
    (0, react_1.useEffect)(function () {
        switch (type) {
            case "morning":
                setCurrentImage(MORNING_IMAGE);
                setCurrentBackground(MORNING_GRADIENT);
                break;
            case "day":
                setCurrentImage(DAY_IMAGE);
                setCurrentBackground(DAY_GRADIENT);
                break;
            case "evening":
                setCurrentImage(EVENING_NIGHT_IMAGE);
                setCurrentBackground(EVENING_GRADIENT);
                break;
            case "night":
                setCurrentImage(EVENING_NIGHT_IMAGE);
                setCurrentBackground(NIGHT_GRADIENT);
                break;
        }
    }, [type]);
    return (react_1.default.createElement(Styled.Container, { backgroundGradient: currentBackground, background: background },
        react_1.default.createElement(Styled.Image, { src: currentImage, draggable: false, x: getX(x), y: getY(y), animation: animation, duration: animationRoundTime }),
        react_1.default.createElement(Styled.Children, null, children)));
};
exports.default = Time;
function getX(x) {
    switch (x) {
        case "left":
            return "left : -10%;";
        case "right":
            return "right : -10%;";
        case "center":
            return "left : 17%; transform : translateX(-50%);";
    }
    return "";
}
function getY(y) {
    switch (y) {
        case "top":
            return "top : -10%;";
        case "bottom":
            return "bottom : -10%;";
        case "center":
            return "top : 17%; transform : translateY(-50%);";
    }
    return "";
}
